const unableToValidate = 'Unable to perform address validation at this time. Try again later or contact staff master support.';
export const MOBILE = (typeof window !== 'undefined') ? (window.screen.availWidth < 800) : true;
export const USE_MOCK_SERVICE: any = { CAN_MOCK: false };

export enum DebugScreen {
  CustomerView = 'CustomerView',
  WriteupDetail = 'WriteupDetail',
  WriteupDetailTrade = 'WriteupDetailTrade',
  InitiatedWriteupModal = 'InitiatedWriteupModal',
  PaymentSimulator = 'PaymentSimulator',
  OCA = 'OCA',
}

export enum DebugAction {
  OpenWriteup = 'OPEN_WRITEUP',
  OpenChat = 'OPEN_CHAT',
  SaveDeal = 'SAVE_DEAL',
  UpdateCustomer = 'UPDATE_CUSTOMER',
  SendOffer = 'SEND_OFFER',
  UpdateDeal = 'UPDATE_DEAL',
  UpdateProtectionProducts = 'UPDATE_PROTECTION_PRODUCTS',
  FinalizeDeal = 'FINALIZE_DEAL',
  ContractApproved = 'CONTRACT_APPROVED',
  SendToFinance = 'SEND_TO_FINANCE',
  CloneDeal = 'CLONE_DEAL',
  CalculatePayment = 'CALCULATE_PAYMENT',
  CalculateRateTerm = 'CALCULATE_RATE_TERM',
  RollPayment = 'ROLL_PAYMENT',
  CalculatePpPayment = 'CALCULATE_PP_PAYMENT',
  GetRebates = 'GET_REBATES',
  UpdateWorksheet = 'UPDATE_WORKSHEET',
  GetProductPrice = 'GET_PRODUCT_PRICE',
  CheckOcaStatus = 'CHECK_OCA_STATUS',
  LoadProtectionProducts = 'LOAD_PROTECTION_PRODUCTS',
  GetTradeVins = 'GET_TRADE_VINS',
  SearchCustomer = 'SEARCH_CUSTOMER',
  CheckPlateTransfer = 'CHECK_PLATE_TRANSFER',
  LoadSimulator = 'LOAD_SIMULATOR',
}

export class ViewConstants {
  static readonly MSD_LABEL = 'Multiple Security Deposit';
  static readonly DEALER_SITE_INVENTORY_INQUIRY='DEALERSITEINVENTORYINQUIRY';
  static readonly DEALER_SITE_INVENTORY_INQUIRY_LABEL='DealerSite Inventory Inquiry';
  static readonly DEALER_SITE_CONTACT_INQUIRY='DEALERSITECONTACTINQUIRY';
  static readonly DEALER_SITE_CONTACT_INQUIRY_LABEL='DealerSite Contact Inquiry';
  static readonly ARROW_DOWN='tmi tmi-arrow-sm-dwn';
  static readonly FRONT_END_GROSS="Front-End Gross";
  static readonly BACK_END_GROSS="Back-End Gross";
  static readonly ACCESSORYDISCOUNTS='Accessory Discounts';
  static readonly INTEGRATE_SERVICE = true;
  static readonly STOCK = 'STOCK #';
  static readonly MODELNO = 'MODEL';
  static readonly MODELDESCRIPTION = 'MODEL DESC';
  static readonly EXTERIORCOLOR = 'EXT. COLOR';
  static readonly EXTERIORCLR = 'EXT CLR';
  static readonly INTERIORCOLOR = 'INT. COLOR';
  static readonly INTERIORCLR = 'INT CLR';
  static readonly CERTIFICATION_NUMBER = 'CERTIFICATION #';
  static readonly MODELYEAR = 'YEAR';
  static readonly CANCEL = 'CANCEL';
  static readonly VIN = 'VIN';
  static readonly ACCESSORIES = 'ACCESSORIES';
  static readonly DIOINDICATOR = 'DIO IND';
  static readonly CATEGORY = 'CAT';
  static readonly DIS = 'DIS';
  static readonly DAYS_ONLINE = 'DAYS ONLINE';
  static readonly OTHER_CAPITALIZED_COSTS ='Other Capitalized Costs'
  static readonly OTHER_AMOUNT_FINANCED = 'Other Amount Financed'
  static readonly ESTIMATED_MONTHLY_PAYMENT = 'Estimated Monthly Payment';
  static readonly ESTIMATED_TOTAL_DUE_AT_LEASE_SIGNING = 'Estimated Total Due At Lease Signing';
  static readonly CAPITALIZED_FEES = 'Capitalized Fees';
  static readonly NON_CAPITALIZED_FEES = 'Non Capitalized Fees';
  static readonly ESTIMATED_GROSS_CAPITALIZED_COST_TOTAL = 'Estimated Gross Capitalized Cost Total';
  static readonly BASE_VEHICLE_SELLING_PRICE = 'Base Vehicle Selling Price';
  static readonly CASH_DOWN_PAYMENT = 'Cash Down Payment';
  static readonly REFUNDABLE_SECURITY_DEPOSIT = 'Refundable Security Deposit';
  static readonly RESIDUAL_VALUE = 'Residual Value';
  static readonly ESTIMATED_FEES = 'Estimated Fees';
  static readonly ESTIMATED_TAXES = 'Estimated Taxes';
  static readonly INCENTIVES_AND_REBATES = 'Incentives & Rebates';
  static readonly TOTAL_OF_PAYMENTS = 'Total of Payments';
  static readonly NET_TRADE_IN = 'Net Trade-In';
  static readonly ESTIMATED_CAPITALIZED_TAXES = 'Estimated Capitalized Taxes';
  static readonly ESTIMATED_NON_CAPITALIZED_FEES = 'Estimated Non-Capitalized Fees';
  static readonly ESTIMATED_NON_CAPITALIZED_TAXES = 'Estimated Non-Capitalized Taxes';
  static readonly ORIGINAL_DEALER = 'ORIGINAL DEALER';
  static readonly DEALER_INVOICE_PRICE = 'INVOICE($)';
  static readonly MAAP = 'MAAP($)';
  static readonly ADVERTIZED_PRICE = 'ADV PRICE($)';
  static readonly SELLING_PRICE = 'EPRICE($)';
  static readonly MSRP = 'MSRP($)';
  static readonly CAMP = 'CAMP';
  static readonly ONLINE = 'ONLINE';
  static readonly HOLD_STATUS = 'HOLD';
  static readonly RDR = 'RDR';
  static readonly TRADEIN_PAYMENT = 'TRADEIN&PAYMENT';
  static readonly COMMENTS = 'COMMENTS';
  static readonly COMMENT = 'COMMENT';
  static readonly HOLD_COMMENTS = 'HOLD COMMENTS';
  static readonly INCENTIVE = 'INCENTIVE';
  static readonly ADD = 'ADD';
  static readonly ITEMNO = 'ITEM NO.';
  static readonly NAME = 'NAME';
  static readonly SOURCE = 'SOURCE';
  static readonly DEALER_INVOICE = 'DEALER INVOICE($)';
  static readonly RETAIL_PRICE = 'RETAIL PRICE($)';
  static readonly FULL_VIEW = 'Full View';
  static readonly PART_NO = 'PART NUMBER';
  static readonly MODELS = 'MODELS';
  static readonly MODEL = 'MODEL';
  static readonly DESCRIPTION = 'DESCRIPTION';
  static readonly DIO_PRICE = 'DIO PRICE($)';
  static readonly DEALER_FEE = 'Dealer Fee';
  static readonly ADVERTISED_PRICE = 'ADVERTISED PRICE';
  static readonly AMOUNT = 'AMOUNT';
  static readonly ATTRIBUTE = 'ATTRIBUTE';
  static readonly DEFAULT = 'DEFAULT';
  static readonly DETAILS = 'DETAILS';
  static readonly TYPE = 'TYPE';
  static readonly VEHICLE = 'VEHICLE';
  static readonly EDIT = 'EDIT';
  static readonly DELETE = 'REMOVE';
  static readonly DISCOUNT_ADV_PRICE = 'ADV DISCOUNT($)';
  static readonly DISCOUNT_EPRICE = 'EPRICE DISCOUNT($)';
  static readonly DISCOUNT_SELLING_PRICE = 'SELLING DISCOUNT($)';
  static readonly APPLIED = 'APPLIED';
  static readonly CUSTOMER_NAME = 'CUSTOMER';
  static readonly STOCK_NUMBER = 'STOCK NUMBER';
  static readonly VIN_NUMBER = 'VIN NUMBER';
  static readonly DEAL_TYPE = 'TYPE';
  static readonly STATUS = 'STATUS';
  static readonly LAST_MODIFIED = 'LAST MODIFIED';
  static readonly ASSOCIATE = 'ASSOCIATE';
  static readonly USD = 'USD';
  static readonly USD_SYMBOL = '$';
  static readonly COMMA = ',';
  static readonly EMPTY_STRING = '';
  static readonly SELECT = 'Select';
  static readonly SELECT_UPPERCASE = 'SELECT';
  static readonly DD_ITSUPPORTADMIN = 'DD_ITSupportAdmin';
  static readonly DD_RTIRETAILDELETEFEATURE = 'DD_RTIRetailDeleteFeature';
  static readonly DD_OFFICESTAFFADMINISTRATION = 'DD_OfficeStaffAdministration';
  static readonly DD_RTIEXPRESSPURCHASEROLE = 'DD_RTIExpressPurchaserole';
  static readonly DD_NEWVEHICLEVMSINCLUDECOST = 'DD_NewVehicleVMSIncludeCost';
  static readonly DD_NEWVEHICLEVMSEXCLUDECOST = 'DD_NewVehicleVMSExcludeCost';
  static readonly DD_SIGNAL = 'DD_Signal';
  static readonly SELECT_VIEW_HEADER = 'SELECT VIEW';
  static readonly DELETE_VIEW_HEADER = 'DELETE';
  static readonly DEFAULT_VIEW_HEADER = 'DEFAULT';
  static readonly SAVE_BUTTON = 'SAVE';
  static readonly CLOSE_ICON = 'close';
  static readonly VEHICLE_DETAIL_SCREEN_NAME = 'Vehicle Details';
  static readonly MANAGE_DIO_SCREEN_NAME = 'Manage DIO';
  static readonly PRICING_PROMOTE_SCREEN_NAME = 'Pricing Promote';
  static readonly GROUP_PRICING_SCREEN_NAME = 'Group Pricing';
  static readonly DIO_ADMIN_SCREEN_NAME = 'DIO Administration';
  static readonly DIO_ADMINDETAIL_SCREEN_NAME = 'DIO Administration ';
  static readonly DIO_ADMIN_MENU_NAME = 'DIO Admin';
  static readonly DEALER_FEES_SCREEN_NAME = 'Dealer Fees';
  static readonly DISCLAIMERS_SCREEN_NAME = 'Disclaimers';
  static readonly DEAL_UPDATE_SCREEN_NAME = 'WRITE-UP UPDATES';
  static readonly DESCRIPTIONS_SCREEN_NAME = 'Descriptions';
  static readonly VEHICLE_HOLD_SCREEN_NAME = 'Vehicle Holds';
  static readonly CUSTOMER_DEALS_SCREEN_NAME = 'Customer/Write-ups';
  static readonly MST_DEAL_DETAIL_SCREEN_NAME = 'MST: WRITE-UP DETAILS';
  static readonly VEHICLE_HISTORY_SCREEN_NAME = 'Vehicle History';
  static readonly TOY = 'TOY';
  static readonly NATIONAL = 'NATIONAL';
  static readonly YES_NO = 'YES-NO';
  static readonly OK_CANCEL = 'OK-CANCEL';
  static readonly PROMOTE = 'Promote';
  static readonly EPRICE = 'ePrice';
  static readonly ADVERTISEPRICE = 'Advertise Price';
  static readonly F = 'F';
  static readonly D = 'D';
  static readonly P = 'P';
  static readonly ALLOCATED = 'Allocated';
  static readonly INTRANSIT = 'InTransit';
  static readonly GROUND = 'Ground';
  static readonly PROMOTED = 'Promoted';
  static readonly OFFLINE = 'Off-Line';
  static readonly ONHOLD = 'On Hold';
  static readonly ASC = 'ASC';
  static readonly DESC = 'DESC';
  static readonly VEHICLE_DETAIL_ROUTING = '/vehicle/';
  static readonly CLEAR_ALL = 'Clear All';
  static readonly DEALER_CATEGORY_A = 'A';
  static readonly DEALER_CATEGORY_F = 'F';
  static readonly DEALER_CATEGORY_G = 'G';
  static readonly DEALER_CATEGORY_GP = 'GP';
  static readonly ONLINE_STATUS_Y = 'Y';
  static readonly ONLINE_STATUS_N = 'N';
  static readonly HOLD_STATUS_YES = 'Yes';
  static readonly EXT_COLOR_FIELDNAME = 'extColor.colorCd';
  static readonly INT_COLOR_FIELDNAME = 'intColor.colorCd';
  static readonly FILTER_VALUE_INTRANSIT = 'I';
  static readonly OPTION_TYPE_D = 'D';
  static readonly SPACE = ' ';
  static readonly SELECTED = 'selected';
  static readonly DOT = '.';
  static readonly GET_FILTER_ACTION_LOGGER = 'GetFilterAction Action Invoked. Parameter : None';
  static readonly SAVE_SHOW_MODEL_LOGGER = 'SaveShowModelStateAction Action Invoked. Parameter : ';
  static readonly SAVE_FILTER_ACTION_LOGGER = 'SaveFilterAction Action Invoked. Parameter : ';
  static readonly SAVE_GRID_FILTER_LOGGER =
  'SaveGridFiltersStateAction Action Invoked. Parameter : ';
  static readonly SAVE_CURRENT_VIEW_LOGGER =
  'SaveCurrentViewStateAction Action Invoked. Parameter : ';
  static readonly SAVE_HEADER_CHECKBOX_LOGGER =
  'SaveHeaderCheckboxStateAction Action Invoked. Parameter : ';
  static readonly DAYS_IN_STOCK = 'daysInStock';
  static readonly DAYS_IN_STOCK_NUMERIC = 'daysInStockNumeric';
  static readonly DAYS_ON_LINE = 'daysOnline';
  static readonly PRICE_MAAP = 'price.maap';
  static readonly PRICE_TOTAL_MSRP = 'price.totalMsrp';
  static readonly PRICE_SELLING_PRICE = 'price.sellingPrice';
  static readonly PRICE_ADVERTIZE_PRICE = 'price.advertizedPrice';
  static readonly PRICE_TOTAL_DEALER_INVOICE = 'price.totalDealerInvoice';
  static readonly PRICE_TOTAL_DIOS_VALUE = 'price.totalDiosValue';
  static readonly PRICE_TOTAL_DEALER_FEE_VALUE = 'price.totalDealerfeeValue';
  static readonly ADV_PRICE_DISCOUNT = 'advPriceDiscount';
  static readonly EPRICE_DISCOUNT = 'ePriceDiscount';
  static readonly MODEL_MODELCD = 'model.modelCd';
  static readonly MODEL_PHASECD = 'model.phaseCd';
  static readonly ACCESSORIES_LOWER_CASE = 'accessories';
  static readonly IN_LIST = 'inlist';
  static readonly NOT_IN_LIST = 'notinlist';
  static readonly STARTS_WITH = 'startsWith';
  static readonly INDEX_OF = 'indexOf';
  static readonly ADD_COMMENTS_SERVICE_CALL_LOGGER = 'service call for add Comments';
  static readonly ADD_COMMENTS_SERVICE_INVOKED_LOGGER = 'add  comments Service invoked - ';
  static readonly GET_COMMENTS_SERVICE_METHOD_LOGGER = 'Get comments Service method.. ';
  static readonly GET_COMMENTS_SERVICE_INVOKED_LOGGER = 'Get comments Service invoked - ';
  static readonly AUTHORIZATION = 'Authorization';
  static readonly ID_TOKEN = 'id-token';
  static readonly USERS = 'users';
  static readonly USER_NAME_DOUBLE_QUOTES = 'Username "';
  static readonly IS_ALREADY_TAKEN = '" is already taken';
  static readonly ROUTER_TRANSITION = 'routerTransition';
  static readonly VOID = 'void';
  static readonly FIXED = 'fixed';
  static readonly HUNDRED_PERCENTAGE = '100%';
  static readonly STAR = '*';
  static readonly COLON_ENTER = ':enter';
  static readonly TRANSLATE_X_HYPHEN_HUNDRED_PERCENTAGE = 'translateX(-100%)';
  static readonly TRANSLATE_X_HUNDRED_PERCENTAGE = 'translateX(100%)';
  static readonly TRANSLATE_Y_HYPHEN_HUNDRED_PERCENTAGE = 'translateY(-100%)';
  static readonly TRANSLATE_Y_HUNDRED_PERCENTAGE = 'translateY(100%)';
  static readonly ZERO_FIVE_S_EASE_IN_OUT = '0.5s ease-in-out';
  static readonly ZERO_SIX_S_EASE_IN_OUT = '0.6s ease-in-out';
  static readonly COLON_LEAVE = ':leave';
  static readonly TRANSLATE_X_ZERO_PERCENTAGE = 'translateX(0%)';
  static readonly TRANSLATE_Y_ZERO_PERCENTAGE = 'translateY(0%)';
  static readonly NUMBER = 'number';
  static readonly REQUIRED_PARAMETER_IS_NULL_OR_UNDEFINED =
  'Catastrophe!! Required parameter is null or undefined while invoking {ServiceName} Services. '
  + 'Parameter Name : {ParameterName}';
  static readonly ERROR_LOG_SERVICE = 'Error Log Service';
  static readonly HTTP_ERROR_WHILE_LOGGING_SERVER = 'Http error while logging to server: ';
  static readonly ERROR_HANDLER = 'ErrorHandler';
  static readonly ERROR_WHEN_TRYING_OUTPUT_ERROR = 'Error when trying to output error.';
  static readonly ERROR_WHEN_TRYING_TO_LOG_ERROR = 'Error when trying to log error to';
  static readonly CONTENT_TYPE = 'Content-Type';
  static readonly APPLICATION_JSON = 'application/json';
  static readonly ACCEPT = 'Accept';
  static readonly AUTHORIZATION_LOWER_CASE = 'authorization';
  static readonly BEARER = 'Bearer ';
  static readonly ID_TOKEN_HTTP_CLIENT = 'id_token';
  static readonly ACCESS_TOKEN_HTTP_CLIENT = 'access_token';
  static readonly RTI = 'rti';
  static readonly GARAGE = '/garage/';
  static readonly MENU = 'menu';
  static readonly SIDENAV_NAME_REGISTERED_ALREADY = 'Sidenav already registered with that name';
  static readonly ICON_VEHICLE_DETAIL = 'Icon-Vehicle-Detail';
  static readonly ICON_DIOS = 'Icon-DIOs';
  static readonly ICON_PRICING_PROMOTE = 'Icon-Pricing-Promote';
  static readonly ICON_HOLD_MANAGEMENT = 'Icon-Hold-Management';
  static readonly ICON_VEHICLE_HISTORY = 'Icon-Vehicle-History';
  static readonly EDIT_DISCLAIMER_LOGGER = 'EditDisclaimerAction action invoked. Parameter : ';
  static readonly DELETE_DISCLAIMER_LOGGER = 'DeleteDisclaimerAction action invoked. Parameter : ';
  static readonly ADD_DISCLAIMER_LOGGER = 'AddDisclaimerAction action invoked. Parameter : ';
  static readonly GET_DISCLAIMER_LOGGER = 'GetDisclaimersAction action invoked. Parameter : ';
  static readonly GET_DISCLAIMER_TYPE_LOGGER =
  'GetDisclaimerTypesAction action invoked. Parameter : null';
  static readonly SET_DIO_FIO_LOGGER = 'SetDioAndFIO Action Invoked. Parameter: dataFormatter';
  static readonly INITIAL_LOAD_LOGGER =
  'InitialLoadAction Action Invoked. Parameter: ';
  static readonly SEMICOLON_SPACE = '; ';
  static readonly DEALERCD = 'dealerCd';
  static readonly COLON_SPACE = ': ';
  static readonly MARKETINGSERIES = 'marketingSeries';
  static readonly GET_DIO_FOR_VIN_LOGGER = 'GetDIODetailsForVINAction Action Invoked. Parameter: ';
  static readonly APPLY_DIO_CHANGES_LOGGER = 'ApplyDIOChangesAction Action Invoked. Parameter: ';
  static readonly GET_INDIVIDUAL_DIO_LOGGER =
  'GetIndividualDIODataAction Action Invoked. Parameter: ';
  static readonly GET_PROMOTE_DESCRIPTION_LOGGER =
  'GetPromoteDescriptionAction Action Invoked. Parameter : ';
  static readonly DESCRIPTION_SAVE_LOGGER = 'DescriptionsSaveAction Action Invoked. Parameter : ';
  static readonly FILE_DOWNLOAD_ICON = 'file_download';
  static readonly PRINT_ICON = 'print';
  static readonly HELP_ICON = 'help';
  static readonly ACTIVATE_EVENT = 'Activate Event:';
  static readonly DE_ACTIVATE_EVENT = 'Deactivate Event';
  static readonly DEVELOPMENT = 'development';
  static readonly INSIDE_AUTH_REDUCER_LOG = 'inside auth reducer - ';
  static readonly AUTH_USER_SET_LOG = 'Auth user set - ';
  static readonly DELETE_DISCLAIMER_FAIL_MESSAGE =
  '409 - OK Conflict';
  static readonly HOLD_COMMENTS_USER_VIEW = 'holdComments';
  static readonly INCENTIVE_LOWER_CASE = 'incentive';
  static readonly DEALER_CATEGORY = 'dealerCategory';
  static readonly ONLINE_STATUS = 'Online';
  static readonly CUSTOMER_HOLD = 'Customer Hold';
  static readonly YES = 'Yes';
  static readonly NO = 'No';
  static readonly NA = 'NA';
  static readonly TOYOTA = 'TOYOTA';
  static readonly LEXUS = 'LEXUS';
  static readonly AFTER_MARKET = 'AFTER MARKET';
  static readonly UNDEFINED_UPPER_CASE = 'UNDEFINED';
  static readonly NULL_UPPER_CASE = 'NULL';
  static readonly SOURCE_TYPE = 'SOURCE_TYPE';
  static readonly SEARCH_TEXT = 'SEARCH_TEXT';
  static readonly DECIMAL_AD_PRICE = 'decimalAdvPrice';
  static readonly DECIMAL_EPRICE = 'decimalEPrice';
  static readonly ADVPRICE = 'ADVPRICE';
  static readonly ERROR_FIELD = 'errorField';
  static readonly MANDATORY_ERROR_FIELD = 'mandatoryErrorField';
  static readonly CURRENT_OPERATION_OFFLINE = 'OFFLINE';
  static readonly CUSTOM = 'CUSTOM';
  static readonly HYPHEN = '-';
  static readonly VIN_WITH_CURLY = '{vins}';
  static readonly MSRP_DIO = 'MSRP + DIO';
  static readonly INVOICE_DIO = 'INVOICE + DIO';
  static readonly INVOICE_RULE = 'INVOICE';
  static readonly MSRP_RULE = 'MSRP';
  static readonly DEALER_INVOICE_RULE = 'DEALER INVOICE';
  static readonly RETAIL_PRICE_RULE = 'RETAIL PRICE';
  static readonly PROMOTE_VEHICLE_LOGGER = 'PromoteVehicleAction Action Invoked. Parameter: ';
  static readonly OFFLINE_VEHICLE_LOGGER = 'OfflineVehicleAction Action Invoked. Parameter: ';
  static readonly INITIAL_LOAD_LOGGER_NULL = 'InitialLoadAction Action Invoked. Parameter: null';
  static readonly VEHICLE_PRICING_ROUTING = '/pricing/';
  static readonly TRADE_SIGNAL_ROUTE = '/flags';
  static readonly PRE_SOLD_ROUTE = '/presold';
  static readonly SAVE_VEHICLE_LOGGER = 'SaveVehicleAction Action Invoked. Parameter: ';
  static readonly DIO_EDIT_ACCESSORY_LOGGER =
  'DIOAdminDetailEditAccessory action invoked. Parameter: ';
  static readonly DIO_ADD_ACCESSORY_LOGGER =
  'DIOAdminDetailCreateNewAccessory action invoked. Parameter: ';
  static readonly DIO_ADMIN_LIST_ROUTING = '/dioadminlist';
  static readonly DIO_ADMIN_DETAIL_LOAD_DIO_LOGGER =
  'DIOAdminDetailLoadDIOData action invoked. Parameter: ';
  static readonly PART_NUMBER = 'partNumber';
  static readonly DIO_ADMIN_DETAIL_INITIAL_LOAD =
  'DIOAdminDetailNewAccessoryInitialLoad action invoked. Parameter: None';
  static readonly EFC_DATA_LOAD_LOGGER =
  'EFCDataLoadAction action invoked. Parameter: brand : TOY ; regionName : NATIONAL';
  static readonly ADD_SLIDES = 'slides - ';
  static readonly M = 'M';
  static readonly PERCENTAGE_SYMBOL = '%';
  static readonly SAVE_PRICING_LOGGER = 'save clicked!';
  static readonly CANCEL_PRICING_LOGGER = 'Cancel clicked!';
  static readonly OPEN_DEALER_FEE_POPUP = 'OpenDealerFeePopup emitted!';
  static readonly TERMS_ACCEPTED_LOGGER = 'terms accepted';
  static readonly APPLY = 'APPLY';
  static readonly RESET = 'RESET';
  static readonly OFFLINE_CAMEL_CASE = 'Offline';
  static readonly DEFAULT_PROMOTE_DESCRIPTION_LOGGER =
  'GetDefaultPromoteDescriptionAction Action Invoked. Parameter: ';
  static readonly DEFAULT_PROMOTE_DISCLAIMER_LOGGER =
  'GetDefaultPromoteDisclaimerAction Action Invoked. Parameter: ';
  static readonly SAVE_OFFLINE_ACTION_LOGGER = 'SaveOffline Action Invoked. Parameter: ';
  static readonly SAVE_PROMOTE_ACTION_LOGGER = 'SavePromote Action Invoked. Parameter: ';
  static readonly CONTAINER_CALLED_LOGGER = 'container called!';
  static readonly DIALOG_SERVICE_MESSAGE =
  'The changes will be pushed to market place. Do you want to continue?';
  static readonly OK = 'OK';
  static readonly SAVE_PRICING_PROMOTE_LOGER =
  'SavePricingPromote Action Invoked. Parameter:invokeSavePromote:false; invokeSaveOffline:true';
  static readonly PREVIEW_VEHICLE = 'PREVIEW VEHICLE';
  static readonly PROMOTE_CONTAINER_LOGGER = 'promote container called!';
  static readonly TAKE_OFFLINE_LOGGER = 'takeOffline container called!';
  static readonly OPEN_DEALER_FEE_POPUP_LOGGER = 'openDealerFeePopup invoked in container';
  static readonly UPDATE_ADV_PRICE_LOGGER = 'UpdateAdPriceAction Action Invoked. Parameter:';
  static readonly UPDATE_SELLING_PRICE_LOGGER =
  'UpdateSellingPriceAction Action Invoked. Parameter:';
  static readonly CANCE_CHANGES_LOGGER = 'cancel changes: ';
  static readonly PROMOTE_DESCRIPTION = 'Promotion Description';
  static readonly UPDATE_PROMOTE_DESCRIPTION_LOGGER =
  'promoteDescriptionText action invoked. Parameter : ';
  static readonly PROMOTE_SAVING_LOGGER =
  'SavePricingPromote Action Invoked. Parameter: vehicle: invokeSavePromote: true ;' +
  'invokeSaveOffline: false ;invokeSaveOfflineByClickingSaveButton: false';
  static readonly TAKE_OFFLINE_SAVE_LOGGER =
  'SavePricingPromote Action Invoked. Parameter: vehicle: invokeSavePromote: false ;' +
  'invokeSaveOffline: true ; invokeSaveOfflineByClickingSaveButton: false';
  static readonly VEHICLE_SERVICE_VIN_METHOD_LOGGER =
  'Executing Get Vehicle By VIN method';
  static readonly GET_VEHICLES_BY_VIN_MOCKMETHOD_LOGGER =
  'Search Vehicles details static data invoked - ';
  static readonly GET_VEHICLES_BY_VIN_SERVICE_LOGGER =
  'Get Vehicle By VIN Service invoked - ';
  static readonly VEHICLES_RESPONSE_RECEIVED_LOGGER =
  'vehicles object response received ';
  static readonly GET_VEHICLES_VIN_ARRAY_METHOD_LOGGER =
  'Executing Get Vehicle By VIN Array method : ';
  static readonly GET_VEHICLES_VIN_ARRAY_STATIC_METHOD_LOGGER =
  'Executing Get static Vehicle By VIN method : ';
  static readonly RESIDUAL_SERVICE_METHOD_LOGGER = 'Enter Residual Service Method';
  static readonly RESIDUAL_MOCK_SERVICE_LOGGER = 'Enter Residual mock service method';
  static readonly RESIDUAL_RESOPONSE_RECEIVED_LOGGER = 'residual object response received ';
  static readonly EXECUTING_SEARCH_VEHICLES_LOGGER = 'Executing Search Vehicles method';
  static readonly SEARCH_VEHICLE_SERVICE_LOGGER = 'Search Vehicles Service invoked - ';
  static readonly SEARCH_VEHICLE_STATIC_DATA_LOGGER = 'Search Vehicles static data invoked - ';
  static readonly GET_DIO_LOGGER = 'Executing Get DIO Master List method';
  static readonly GET_DIO_MASTER_LIST_LOGGER = 'Get DIO Master List Service invoked - ';
  static readonly DIO_OBJECT_RESPONSE_LOGGER = 'Dios object response received ';
  static readonly GET_ASSOCIATED_DIO_LOGGER = 'Executing Get Associated DIO List method';
  static readonly GET_ASSOCIATED_DIO_SERVICE_LOGGER = 'Get Associated DIO List Service invoked - ';
  static readonly GET_ASSOCIATED_DIO_RESPONSE_LOGGER =
  'Dios of the selected Vehicle object response received ';
  static readonly EXECUTING_UPDATE_DIO_LOGGER = 'Executing Update DIO method';
  static readonly UPDATE_DIO_SERVICE_LOGGER = 'Update DIO Service invoked - ';
  static readonly EXECUTING_LOAD_DIO_LOGGER = 'Executing Load DIO method';
  static readonly LOAD_DIO_SERVICE_LOGGER = 'Load DIO Service invoked -';
  static readonly EXECUTING_DELETE_VIEW_LOGGER = ' Executing delete view method';
  static readonly DELETE_VIEW_LOGGER = 'Delete View Service Invoked - ';
  static readonly EXECUTING_UPDATE_VIEW_LOGGER = ' Executing update view method';
  static readonly UPDATE_VIEW_LOGGER = 'Update View Service Invoked - ';
  static readonly EXECUTING_DEFAULT_VIEW_LOGGER = ' Executing update default view method';
  static readonly UPDATE_DEFAULT_VIEW_LOGGER = 'Update Default View Service Invoked - ';
  static readonly EXECUTING_SAVE_VIEW_LOGGER = ' Executing save view method';
  static readonly SAVE_VIEW_LOGGER = 'Save View Service Invoked - ';
  static readonly EXECUTING_GET_VIEW_LOGGER = ' Executing get user view method';
  static readonly GET_USER_VIEW_LOGGER = 'Get User View Service Invoked - ';
  static readonly EXECUTING_GET_PREDEFINED_VIEW_LOGGER = ' Executing get predefined view method';
  static readonly GET_PREDEFINED_VIEW_LOGGER = 'Get Predefined View Service Invoked - ';
  static readonly EXECUTING_SAVE_DESCRIPTION_LOGGER =
  'Executing save Description Service method..';
  static readonly GET_PROMOTE_DESC_SERVICE_LOGGER = 'get promote description Service invoked - ';
  static readonly GET_PROMOTE_DESC_LOGGER = 'service call for get promote description details - ';
  static readonly EXECUTING_GET_PROMOTE_DESC_LOGGER =
  ' Executing get Promote details Service method.. ';
  static readonly SAVE_PROMOTE_DESC_LOGGER = 'Save  Promote description Service invoked - ';
  static readonly SAVE_PROMOTE_LOGGER = 'service call for save promote - ';
  static readonly EXECUTING_CREATE_DIO_LOGGER = 'Executing Create New DIO method';
  static readonly CREATE_NEW_DIO_SERVICE_LOGGER = 'Create New DIO Service invoked - ';
  static readonly EXECUTING_EDIT_DIO_LOGGER = 'Executing Edit Existing DIO method';
  static readonly EDIT_DIO_SERVICE_LOGGER = 'Edit Existing DIO Service invoked - ';
  static readonly DEALER_SUB_CATEGORY_G_STAR = 'G*';
  static readonly RESERVE = 'RESERVE';
  static readonly AVAILABLE = 'AVAILABLE';
  static readonly DEALER_SUB_CATEGORY = 'dealerSubCategory';
  static readonly RDR_STATUS = 'rdrStatus';
  static readonly CUST_NAME = 'custName';
  static readonly TOOLTIP_BREAK = '\n';
  static readonly TOOLTIP_MESSAGE_HYPHEN = '-';
  static readonly NEW_INTERFACE = 'NEWINTERFACE';
  static readonly QUEUED = 'QUEUED';
  static readonly PENDING = 'PENDING';
  static readonly RECEIPT = 'Receipt';
  static readonly DEALER_HOLD = 'DEALERHOLD';
  static readonly HTML_BREAK = '<br />';
  static readonly HTML_UL_OPEN = '<ul>';
  static readonly HTML_UL_CLOSE = '</ul>';
  static readonly HTML_LI_OPEN = '<li>';
  static readonly HTML_LI_CLOSE = '</li>';
  static readonly VISITED_STATUS = 'READ';
  static readonly HIDE_SHOW = 'HIDE/SHOW';
  static readonly DRAFT = 'draft';
  static readonly PUBLISHED = 'published';
  static readonly DIO_FAILURE_REASON = 'partVehicleAssignedCanNotModifyError';
  static readonly DEAL_TYPE_FINANCE = 'finance';
  static readonly DEAL_TYPE_TRADE_FINANCE = 'trade - finance';
  static DEAL_TYPE_CASH = 'cash';
  static DEAL_TYPE_TRADE_CASH = 'trade - cash';
  static readonly DEAL_TYPE_LEASE = 'lease';
  static readonly DEAL_TYPE_TRADE_LEASE = 'trade - lease';
  static readonly ONE_PAY_LEASE = '1_pay_lease';
  static readonly SIGN_AND_DRIVE_LEASE = 'sign_and_drive_lease';
  static readonly REGULAR_LEASE = 'regular_lease';
  static readonly DEAL_TYPE_TRADE = 'trade';
  static readonly DEAL_TYPE_RETAIL = 'retail';
  static readonly DEAL_STATUS_APPROVED = 'approved';
  static readonly EXPIRED_MST = 'Expired';
  static readonly CANCELLED_MST = 'Cancelled';
  static readonly DFI_SUBMITTED = 'DFI Submitted';
  static readonly DEAL_STATUS_CUSTOMER_ACCEPTED = 'finalized';
  static readonly ONLINE_STATUS_READY_FOR_DEALER = 'Ready for Dealer';
  static readonly ROLE_SALES_PERSON = 'Sales Person';
  static readonly ROLE_SALES_MANAGER = 'Sales Manager';
  static readonly VISIBLE = 'VISIBLE';
  static readonly LAST_MODIFIED_DATE = 'LAST MODIFIED DATE';
  static readonly Y = 'Y';
  static readonly N = 'N';
  static readonly ERROR_404 = '404';
  static readonly ADD_DIO_IMAGE = 'Add DIO Image';
  static readonly EDIT_DIO_IMAGE = 'Edit DIO Image';
  static readonly ERROR_FETCHING_DISCLAIMERS = 'Error in fetching disclaimers';
  static readonly CREDIT_RANGE = 'Credit Range';
  static readonly TRADE_IN = 'TRADE - IN';
  static readonly TRADEIN = 'TRADEIN';
  static readonly ACCESSORIES_SENTENCE_CASE = 'Accessories';
  static readonly SELECT_DIO_SCREEN_NAME = 'SELECT DIO';
  static readonly QA = 'qa';
  static readonly RTI_DASHBOARD = 'RTI DASHBOARD';
  static readonly EXECUTING_UPLOAD_DIO_IMAGE_LOGGER = 'Executing upload image method';
  static readonly UPLOAD_DIO_IMAGE_SERVICE_LOGGER = 'Upload Image Service invoked - ';
  static readonly INCENTIVES_REBATES = 'Incentives & Rebates';
  static readonly MILITARY = 'Military';
  static readonly COLLEGE_STUDENT = 'College/Student';
  static readonly LOYALTY = 'Loyalty';
  static readonly VEHICLE_PRICE_CHANGED_EVENT = 'vehicle-dealer-price-changed-event';
  static readonly VEHICLE_ADVPRICE_CHANGED_EVENT = 'vehicle-advprice-changed-event';
  static readonly VEHICLE_EPRICE_CHANGED_EVENT = 'vehicle-eprice-changed-event';
  static readonly VEHICLE_DIO_UPDATED_EVENT = 'vehicle-dio-changed-event';
  static readonly VEHICLE_PROMOTED_EVENT = 'vehicle-promoted-event';
  static readonly VEHICLE_OFFLINE_EVENT = 'vehicle-offlined-events';
  static readonly OFFLINED_EVENT = 'vehicle-offlined-event';
  static readonly EXECUTING_GET_DEALER_FEATURES = 'Executing get dealer features method';
  static readonly GET_DEALER_FEATURE_SERVICE_LOGGER = 'Get Dealer Feature Service Invoked - ';
  static readonly LOCAL_TAXES_FEES = 'Local Taxes & Fees Details';
  static readonly VEHICLE_ON_GROUND_EVENT = 'vehicle-on-ground-event';
  static readonly VEHICLE_RDR_INITIATED_EVENT = 'vehicle-rdr-initiated-event';
  static readonly VEHICLE_RDR_CANCELLED_EVENT = 'vehicle-rdr-cancelled-event';
  static readonly VEHICLE_RETURN_TO_STOCK_EVENT = 'vehicle-return-to-stock-event';
  static readonly VEHICLE_RESERVED_EVENT = 'vehicle-reserved-event';
  static readonly VEHICLE_UNRESERVED_EVENT = 'vehicle-unreserved-event';
  static readonly VEHICLE_COMMENTS_UPDATED_EVENT = 'vehicle-comments-updated-event';
  static readonly VEHICLE_TRADED_EVENT = 'vehicle-traded-event';
  static readonly VEHICLE_SSC_OPEND_EVENT = 'vehicle-ssc-opened-event';
  static readonly VEHICLE_SSC_CLOSED_EVENT = 'vehicle-ssc-closed-event';
  static readonly VEHICLE_STOCK_NO_UPDATED_EVENT = 'vehicle-stock-no-updated-event';
  static readonly VEHICLE_STOPSALE_CODE_CHANGED_EVENT = 'vehicle-stopsale-code-changed-event';
  static readonly VEHICLE_FLEET_INDICATOR_CHANGED_EVENT = 'vehicle-fleet-indicator-changed-event';
  static readonly VEHICLE_DEMO_CODE_EVENT = 'vehicle-demo-event';
  static readonly RETAIL_PRICE_LABEL = 'Retail Price';
  static readonly DEALER_PRICE_ADJUSTMENT = 'Dealer Price Adjustment';
  static readonly OPTIONAL_ACCESSORIES = 'Optional Accessories';
  static readonly ESTIMATED_TAXES_AND_FEES = 'Estimated Taxes & Fees';
  static readonly DEALER_INVOICE_PRICE_LABEL = 'Dealer Invoice Price';
  static readonly VEHICLE_ADDED_TO_STOCK = 'Vehicle added to stock';
  static readonly RDR_INITIATED = 'RDR initiated';
  static readonly RDR_CANCELLED = 'RDR cancelled';
  static readonly RETURNED_TO_STOCK = 'Returned to stock';
  static readonly VEHICLE_RESERVED = 'Vehicle Reserved';
  static readonly VEHICLED_TRADED_IN = 'Vehicled traded in';
  static readonly STOCK_NUMBER_UPDATED = 'Stock number updated';
  static readonly VEHICLE_MADE_STOP_SALE = 'Vehicle made stop sale';
  static readonly FLEET_INDICATOR_TURNED_ON = 'Fleet indicator turned on';
  static readonly VEHICLE_MARKED_FOR_DEMO = 'Vehicle marked for demo';
  static readonly NO_DATA_AVAILABLE = 'No Information available at this moment';
  static readonly PENDING_APPROVAL = 'pending review';
  static readonly DEAL_PRICIED = 'write-up priced';
  static readonly VIEWS = 'VIEWS';
  static readonly SAVES = 'SAVES';
  static readonly LEADS = 'LEADS';
  static readonly WRITEUPS = 'writeups';
  static readonly BY_CUSTOMER = 'by customer';
  static readonly LEAD_VIEW = 'Lead View';
  static readonly SALES_AGENT_NAME = 'Sales Agent';
  static readonly DEAL_SUBMITTED_TIME = ' Time';
  static readonly DIO_DELETE_IMAGE = 'DELETE';
  static readonly NAME_CAMEL_CASE = 'Name';
  static readonly PART_NUMBER_CAMEL_CASE = 'Part Number';
  static readonly ANONYMOUS = 'Anonymous';
  static readonly ERROR_MESSAGE_UPLOAD_VALID_IMAGE_FILE = 'Upload valid image file';
  static readonly MST_PROTECTIONS = 'Protection Product Admin';
  static readonly PLANS = 'PLANS';
  static readonly RECOMMENDED = 'RECOMMENDED';
  static readonly DEFAULT_SELECTION = 'DEFAULT SELECTION';
  static readonly TYPE_PLAN = 'TYPE/PLAN';
  static readonly TERMS = 'TERMS';
  static readonly RATES = 'RATES';
  static readonly CASH_DOWN = 'Cash Down';
  static readonly DEDUCTABLE = ' Deductable';
  static readonly LOAD_DEAL_DETAILS_IMAGE_SERVICE_LOGGER =
  'Load deal details Image Service invoked -';
  static readonly GRID = 'GRID';
  static readonly MISSING_PRICE = 'Missing Price';
  static readonly ALL_CATEGORY = 'All Category';
  static readonly FRONTVIEW = 'Front View';
  static readonly DRIVERSIDE = 'Driver Side';
  static readonly PASSENGERSIDE = 'Passenger Side';
  static readonly REARVIEW = 'Rear View';
  static readonly ADDITIONALPHOTES = 'Additional Photos';
  static readonly MST_OFFER = 'MST Offer';
  static readonly MST_LEAD = 'MST Lead';
  static readonly DIGITAL_GARAGE_LEAD = 'Digital Garage Lead';
  static readonly OFFER = 'Offer';
  static readonly DEALER_CONTACT = 'Dealer Contact';
  static readonly TEST_DRIVE = 'Test Drive';
  static readonly PAYMENT_ESTIMATOR = 'Payment Estimator';
  static readonly MST_LEAD_DETAIL_SCREEN_NAME = 'MST: LEAD DETAILS';
  static readonly MST_CUSTOMER_ACTIVITY_SCREEN_NAME = 'MST: CUSTOMER ACTIVITY';
  static readonly MISSING_DISCLAIMER = 'Missing Disclaimer';
  static readonly ROUTE_DASHBOARD = 'dashboard';
  static readonly FEATURE_DASHBOARD = 'RTI-DASHBOARD';
  static readonly ROUTE_VEHICLE = 'vehicle';
  static readonly FEATURE_VEHICLE = 'RTI-VEHICLEDETAIL';
  static readonly ROUTE_MANAGEDIO = 'vehicle-dio';
  static readonly FEATURE_MANAGEDIO = 'RTI-MANAGEDIO';
  static readonly ROUTE_PRICINGPROMOTE = 'pricing';
  static readonly FEATURE_PRICINGPROMOTE = 'RTI-PRICINGPROMOTE';
  static readonly ROUTE_GROUPPRICING = 'grouppricing';
  static readonly FEATURE_GROUPPRICING = 'RTI-GROUPPRICING';
  static readonly ROUTE_VEHICLEHISTORY = 'vehicle-history';
  static readonly FEATURE_VEHICLEHISTORY = 'RTI-VEHICLEHISTORY';
  static readonly ROUTE_DIOADMINSUMMARY = 'dioadminlist';
  static readonly FEATURE_DIOADMINSUMMARY = 'RTI-DIOADMINSUMMARY';
  static readonly ROUTE_DIOADMINDETAIL = 'dioAdminDetail';
  static readonly FEATURE_DIOADMINDETAIL = 'RTI-DIOADMINDETAIL';
  static readonly ROUTE_DISCLAIMERADMIN = 'disclaimers';
  static readonly FEATURE_DISCLAIMERADMIN = 'RTI-DISCLAIMERADMIN';
  static readonly FEATURE_DIOADMINLIST_EDIT_RETAILPRICE_VISISBLE = 'RTI-DIOADMINLIST-EDIT-RETAILPRICE-VISISBLE';
  static readonly ROUTE_DESCRIPTIONADMIN = 'descriptions';
  static readonly FEATURE_DESCRIPTIONADMIN = 'RTI-DESCRIPTIONADMIN';
  static readonly ROUTE_FEATURE_WRITEUPSLEADS = 'wl';
  static readonly ROUTE_CUSTOMERDEALSUMMARY = 'summary';
  static readonly FEATURE_WRITEUPSLEADS = 'RTI-WRITEUPSLEADS';
  static readonly ROUTE_FEATURE_CUSTOMERSUMMARY = 'cs';
  static readonly ROUTE_CUSTOMERSUMMARY = 'customer-summary';
  static readonly FEATURE_CUSTOMERSUMMARY = 'RTI-CUSTOMERSUMMARY';
  static readonly ROUTE_FEATURE_WRITEUPDETAILS = 'wd';
  static readonly ROUTE_WRITEUPDETAILS = 'writeup-detail';
  static readonly FEATURE_WRITEUPDETAILS = 'RTI-WRITEUPDETAILS';
  static readonly ROUTE_FEATURE_FIADMIN = 'fi';
  static readonly ROUTE_FIADMIN = 'admin';
  static readonly FEATURE_FIADMIN = 'RTI-FIADMIN';
  static readonly ROUTE_FEATURE_CUSTOMERVIEW = 'cv';
  static readonly ROUTE_CUSTOMERVIEW = 'customer-view';
  static readonly FEATURE_CUSTOMERVIEW = 'RTI-CUSTOMERVIEW';
  static readonly FEATURE_CUSTOMERDEALSUMMARY = 'RTI-CUSTOMERDEALSUMMARY';
  static readonly ROUTE_CUSTOMERDEALDETAIL = 'deal-detail';
  static readonly ROUTE_CUSTOMERDEALALERT = 'deal-alert';
  static readonly FEATURE_CUSTOMERDEALDETAIL = 'RTI-CUSTOMERDEALDETAIL';
  static readonly ROUTE_CUSTOMERLEADDETAIL = 'lead-detail';
  static readonly ROUTE_CUSTOMERACTIVITYDETAIL = 'customer-activity';
  static readonly FEATURE_CUSTOMERLEADDETAIL = 'RTI-CUSTOMERLEADDETAIL';
  static readonly FEATURE_CUSTOMERACTIVITYDETAIL = 'RTI-CUSTOMERACTIVITYDETAIL';
  static readonly ROUTE_DEALNOTIFICATION = 'deal-notification';
  static readonly FEATURE_DEALNOTIFICATION = 'RTI-DEALNOTIFICATION';
  static readonly ROUTE_VEHICLEHOLD = 'vehicle-hold';
  static readonly FEATURE_VEHICLEHOLD = 'RTI-VEHICLEHOLD';
  static readonly ROUTE_DEALERCONFIGURATION = 'dealer-configuration';
  static readonly FEATURE_DEALERCONFIGURATION = 'RTI-DEALERCONFIGURATION';
  static readonly PRODUCTION = 'production';
  static readonly TEST = 'test';
  static readonly STAGE = 'stage';
  static readonly E2E = 'e2e';
  static readonly DEALER_HOLD_CAMELCASE = 'DealerHold';
  static readonly AVAILABLE_CAMELCASE = 'Available';
  static readonly ADVERTISED_PRICE_AGE = 'advprice';
  static readonly EPRICE_AGE = 'eprice';
  static readonly DEAL_STATE = 'finalize';
  static readonly CAP_NON_CAP_COSTS = 'REVIEW CAPITALIZED COSTS';
  static readonly AUDIT = 'AUDIT'
  static readonly PRICE_AGE = 'Price Not Changed';
  static readonly ADV_PRICE_AGEING_7 = 'adv_price_ageing_7';
  static readonly ADV_PRICE_AGEING_14 = 'adv_price_ageing_14';
  static readonly ADV_PRICE_AGEING_30 = 'adv_price_ageing_30';
  static readonly EPRICE_AGEING_7 = 'eprice_ageing_7';
  static readonly EPRICE_AGEING_14 = 'eprice_ageing_14';
  static readonly EPRICE_AGEING_30 = 'eprice_ageing_30';
  static readonly TRADE_IN_PRICE_CHANGES = ' You have unsaved changes, the system will'
  + ' save these changes before proceeding';
  static readonly ADVERTISED_DISCLAIMER_MISSING = `Advertise Price type disclaimers
   are mandatory if Advertised price is set`;
  static readonly EPRICE_DISCLAIMER_MISSING = `Selling Price type disclaimers
   are mandatory if Selling Price is set`;
  static readonly ADVERTISED_EPRICE_DISCLAIMER_MISSING = `Advertise Price and Selling Price type disclaimers
   are mandatory if Advertised price and Selling Price are set`;
  static readonly PENDING_TRADE = 'Pending';
  static readonly TRADE_IN_CLOSE = 'You have at least one trade in pending evaluation';
  static readonly TRADE_IN_VALUE_MESSAGE='Please confirm trade-in valuation before approving the write-up.'
  static readonly PENDING_APPROVAL_MST = 'Pending Review';
  static readonly TRADE_APPROVED_MST = 'Trade Approved';
  static readonly CUSTOMER_ACCEPTED = "CUSTOMER ACCEPTED";
  static readonly APPROVED_MST = 'Dealer Approved';
  static readonly INITIATED = 'Initiated';
  static readonly NOT_VISITED_MST = 'NotVisited';
  static readonly NOT_VISITED_DG = 'NotVisited_DG';
  static readonly DEALER_PRICING_PROCESSOR = 'dealer-pricing-processor';
  static readonly DEALER_CONFIG_SCREEN = 'Dealer Configuration';
  static readonly FEATURE = 'feature';
  static readonly ACTIVE = 'ACTIVE';
  static readonly DEALER_VALUE = 'DEALER VALUE';
  static readonly DEALER_VALUE_PRICED_AT = 'DEALER VALUE PRICED AT';
  static readonly ADD_FEATURE = 'ADD FEATURE';
  static readonly ACTIVITY_ATTRIBUTE = 'ACTIVITY / ATTRIBUTE';
  static readonly EDITABLE = 'EDITABLE';
  static readonly DATATYPE = 'DATA TYPE';
  static readonly EVENT_TYPE_SYSTEM = 'UI';
  static readonly DEFAULT_VALUE = 'DEFAULT VALUE';
  static readonly SOURCE_SYSTEM = 'SOURCE SYSTEM';
  static readonly DEAL_TRANSACTION_ID = 'DEAL TRANSACTION ID';
  static readonly CUSTOMER_MST_ID = 'CUSTOMER MST ID';
  static readonly CUSTOMER_UNIQUE_ID = 'CUSTOMER UNIQUE ID';
  static readonly CREATION_DATE = 'CREATION DATE';
  static readonly DEAL_EXPIRY_DATE = 'DEAL EXPIRY DATE';
  static readonly DEAL_VISITED_STATUS = 'DEAL VISITED STATUS';
  static readonly DEAL_VISITED_BY = 'DEAL VISITED BY';
  static readonly DEAL_LAST_VISITED_DATE = 'DEAL LAST VISITED DATE';
  static readonly CUSTOMER_EMAIL = 'CUSTOMER EMAIL';
  static readonly CUSTOMER_PHONE_NUMBER = 'CUSTOMER PHONE NUMBER';
  static readonly CUSTOMER_STREET = 'CUSTOMER STREET';
  static readonly CUSTOMER_CITY = 'CUSTOMER CITY';
  static readonly CUSTOMER_STATE = 'CUSTOMER STATE';
  static readonly CUSTOMER_ZIPCODE = 'CUSTOMER ZIPCODE';
  static readonly CUSTOMER_COUNTRY = 'CUSTOMER COUNTRY';
  static readonly PREFERRED_CONTACT_CHANNEL = 'PREFERRED CONTACT CHANNEL';
  static readonly WRITEUP_CUSTOMER_ACCEPTANCE = 'WRITE-UP CUSTOMER ACCEPTANCE';
  static readonly RCF_APR = 'APR or RCF';
  static readonly APR = 'APR';
  static readonly RCF = 'RCF';
  static readonly CASHDOWN = 'CASHDOWN';
  static readonly CASHDOWN_APPLIED_TO_INCEPTION_FEES = 'CASHDOWN APPLIED TO INCEPTION FEES';
  static readonly MILES_PER_YEAR = 'MILES PER YEAR';
  static readonly MONTHLYPAYMENT = 'MONTHLYPAYMENT';
  static readonly OFFERTYPE = 'OFFERTYPE';
  static readonly RESIDUALVALUE = 'RESIDUALVALUE';
  static readonly SECURITYDEPOSIT = 'SECURITYDEPOSIT';
  static readonly CUSTOMER_CREDIT_SCORE = 'CUSTOMER CREDIT SCORE';
  static readonly AMOUNT_DUE_AT_SIGNING = 'Amount Due At Signing';
  static readonly INTEGRATE_TOTAL_OF_PAYMENTS: boolean = false; //if true - Total Of Payments will be visible.
  static readonly TOTAL_AMOUNT_FINANCED = 'Total Amount Financed';
  static readonly TOTAL_ESTIMATE_NET = 'Total Estimated Net Amount Due';
  static readonly TERM_LENGTH = 'TERM_LENGTH';
  static readonly VEHICLE_ID = 'VEHICLE ID';
  static readonly VEHICLE_IMAGE_URL = 'VEHICLE IMAGE URL';
  static readonly VEHICLE_JELLY_IMAGE_URL = 'Vehicle Jelly Image URL';
  static readonly VEHICLE_SELLING_PRICE = 'Vehicle Selling Price';
  static readonly CURRENT_ESTIMATE='Current Estimate';
  static readonly EXTERIOR_COLOR_CODE = 'EXTERIOR COLOR CODE';
  static readonly EXTERIOR_COLOR_HEX_CODE = 'EXTERIOR COLOR HEX CODE';
  static readonly INTERIOR_COLOR_CODE = 'INTERIOR COLOR CODE';
  static readonly INTERIOR_COLOR_SWATCH_URL = 'INTERIOR COLOR SWATCH URL';
  static readonly MILEAGE = 'MILEAGE';
  static readonly MILEAGE_AVERAGE = 'MILEAGE AVERAGE';
  static readonly MILEAGE_CITY = 'MILEAGE CITY';
  static readonly MILEAGE_HIGHWAY = 'MILEAGE HIGHWAY';
  static readonly TRADED_VEHICLE_AVAILABILITY = 'TRADED VEHICLE AVAILABILITY';
  static readonly TRADE_SOURCE = 'TRADE SOURCE';
  static readonly TRADED_VEHICLE_1_ID = 'TRADED VEHICLE 1-ID';
  static readonly TRADED_VEHICLE_1_VIN = 'TRADED VEHICLE 1-VIN';
  static readonly TRADED_VEHICLE_1_MAKE = 'TRADED VEHICLE 1-MAKE';
  static readonly TRADED_VEHICLE_1_MILEAGE = 'TRADED VEHICLE 1-MILEAGE';
  static readonly TRADED_VEHICLE_1_SALES_ASSOCIATE_NOTES = 'TRADED VEHICLE 1-SALES ASSOCIATE NOTES';
  static readonly TRADED_VEHICLE_1_PAYOFF = 'TRADED VEHICLE 1-PAYOFF';
  static readonly TRADED_VEHICLE_1_TRADE_OFFER = 'TRADED VEHICLE 1-TRADE OFFER';
  static readonly TRADED_VEHICLE_1_NET_TRADE_IN = 'TRADED VEHICLE 1-NET TRADE-IN';
  static readonly TRADED_VEHICLE_2_ID = 'TRADED VEHICLE 2-ID';
  static readonly TRADED_VEHICLE_2_VIN = 'TRADED VEHICLE 2-VIN';
  static readonly TRADED_VEHICLE_2_MAKE = 'TRADED VEHICLE 2-MAKE';
  static readonly TRADED_VEHICLE_2_MILEAGE = 'TRADED VEHICLE 2-MILEAGE';
  static readonly TRADED_VEHICLE_2_SALES_ASSOCIATE_NOTES = 'TRADED VEHICLE 2-SALES ASSOCIATE NOTES';
  static readonly TRADED_VEHICLE_2_PAYOFF = 'TRADED VEHICLE 2-PAYOFF';
  static readonly TRADED_VEHICLE_2_TRADE_OFFER = 'TRADED VEHICLE 2-TRADE OFFER';
  static readonly TRADED_VEHICLE_2_NET_TRADE_IN = 'TRADED VEHICLE 2-NET TRADE-IN';
  static readonly TRADED_STATUS = 'TRADED STATUS';
  static readonly DEAL_ID = 'DEAL ID';
  static readonly PRICEEXPIRYDATE = 'PRICEEXPIRYDATE';
  static readonly CHAR = 'char';
  static readonly BOOLEAN = 'boolean';
  static readonly STRING = 'string';
  static readonly INTEGER = 'integer';
  static readonly SELECT_FIELD = 'SELECT';
  static readonly DATE_AND_TIME = 'DATE / TIME';
  static readonly UNREAD = 'UNREAD';
  static readonly YEAR = 'YEAR';
  static readonly SERIES = 'SERIES';
  static readonly EVENT = 'EVENT';
  static readonly FAILURE = 'FAILURE';
  static readonly ACTION = 'ACTION';
  static readonly DEAL_STATUS = 'DEAL STATUS';
  static readonly DATES_COLUMN = 'DATES';
  static readonly DMS_RECORDS = 'DMS RECORDS';
  static readonly PAYMENT_WITH_TAXES = 'PaymentWithTaxes';
  //start  for MSTM-39579
  static readonly ONE_PAY_PAYMENT_WITH_TAXES = '1Pay_LeaseTotalCashPayment_WithTaxes'
  static readonly ONE_PAY_PAYMENT_WITH_OUT_TAXES = '1Pay_LeaseTotalCashPayment_WithoutTaxes'
  static readonly ONE_PAY_TOTALDUE_WITH_TAXES ='1Pay_TotalDueAtLeaseSigning_WithTaxes'
  static readonly ONE_PAY_TOTALDUE_WITH_OUT_TAXES = '1Pay_TotalDueAtLeaseSigning_WithoutTaxes'
  //end for MSTM-39579
  static readonly DISCLAIMERS = 'disclaimers';
  static readonly DISCLOSURES = 'disclosures';
  static readonly TOOL_DISCLAIMER = 'toolDisclaimer';
  static readonly APR_DETAILS = 'aprDetails';
  static RATE_TERM_RETAIL = 'rateTermRetail';
  static readonly LAST_MODIFIED_COLNAME = 'updatedDate.updatedDateAsDate';
  static readonly NOTIFICATION_EVENTS = 'NotificationEvents';
  static readonly NOTIFICATION_DETAILS = 'NotificationDetails';
  static readonly MSRP_PRICE_LABEL = 'MSRP Price';
  static readonly CAP_NONCAP_UNSAVED_MESSAGE = 'Your changes will not be saved.' +
  ' Do you want to continue?';
  static RATE_TERM_LEASE = "rateTermLease";
  static readonly RATE_TERM_CASH = "rateTermCash";
  static RETAIL = "retail";
  static readonly DEALER_COLUMN = 'DEALER #';
  static readonly DEALER_NAME_COLUMN = 'DEALER NAME';
  static readonly DEALER_ADDRESS_COLUMN = 'ADDRESS';
  static readonly DEALER_CITY_COLUMN = 'CITY';
  static readonly DEALER_STATE_COLUMN = 'STATE';
  static readonly DEALER_ZIP_COLUMN = 'ZIP';
  static readonly DEALER_PHONE_COLUMN = 'PHONE';
  static readonly DEALER_BRAND_COLUMN = 'BRAND';
  static readonly DEALER_AREAREGION_NUM_COLUMN = 'AREA/REGION #';
  static readonly DEALER_AREAREGION_STRING_COLUMN = 'AREA/REGION';
  static readonly DEALER_DISTRICT_COLUMN = 'DISTRICT #';
  static readonly VEHICLE_PROMOTE_DESC_UPDATED_EVENT = 'vehicle-promote-desc-updated-event';
  static readonly VEHICLE_PRICE_DISCLAIMERS_UPDATED_EVENT = 'vehicle-price-disclaimers-updated-event';
  static readonly VEHICLE_DISCLAIMERS_UPDATED_EVENT = 'vehicle-disclaimers-updated-event';
  static readonly DEMO = 'Demo';
  static readonly DEALER_CATEGORY_L = 'L';
  static readonly OFFER_LEAD = 'WRITE-UP/LEAD';
  static readonly DEAL_ORIGIN = 'SOURCE/ORIGIN';
  static readonly SELLING_PRICE_LABEL = 'SELLING PRICE($)';
  static readonly SELLING_PRICE_WITHOUT_SYMBOL = 'Selling Price';
  static readonly RTID = 'RTID';
  static readonly DMS = 'DMS';
  static readonly FLAG_Y = 'Y';
  static readonly FLAG_N = 'N';
  static readonly EN_US = 'en-US';
  static readonly HASH = '#';
  static readonly SAVE = 'save';
  static readonly TEMP_SERIAL = 'TEMP SERIAL #';
  static readonly REFRESH_TOKEN_INVOKED = 'refreshTokenInvoked';
  static readonly REFRESH_TOKEN_TIME_PERIOD: number = 240 * 60 * 1000;
  static readonly REFRESH_TOKEN_VERIFICATION_TIME_PERIOD: number = 245 * 60 * 1000;
  static readonly LOGOUT_PERIOD: number = 8 * 60 * 60 * 1000;
  static readonly DISCLAIMER_INDICATOR = 'DISC IND';
  static readonly INSTALLED_PRICE = 'INSTALLED PRICE';
  static readonly INSTALLED_PRICE_LABEL = 'Installed Price';
  static readonly VEHICLE_PRICED_BUT_NOT_PROMOTABLE = `Vehicle is not promotable, prices are saved`;
  static readonly PROMOTE_DISCLAIMER_MISSING = `Promote type disclaimer is mandatory`;
  static readonly PROMOTABLE = 'PROMOTABLE';
  static readonly MIN_ALLOWABLE_ADV_PRICE: number = 0.00;
  static readonly LEAD_TYPE_VEHICLE_SELLING_PRICE = 'Vehicle Selling Price';
  static readonly LEAD_TYPE_OFFER = 'Offer';
  static readonly DEAL_TYPE_OFFER = 'Deal';
  static readonly DEAL_TYPE_EQUITY = 'Equity';
  static readonly DEAL_TYPE_CONFIRM_AVAILABILITY = 'ConfirmAvailability';
  static readonly DEAL_TYPE_CONFIRM_AVAILABILITY_LABEL = 'Confirm Availability';
  static readonly DEAL_TYPE_START_PURCHASE = 'StartPurchase';
  static readonly DEAL_TYPE_TEST_DRIVE = 'TestDrive';
  static readonly DEAL_TYPE_START_PURCHASE_LABEL = 'Start Purchase';
  static readonly DEAL_TYPE_TEST_DRIVE_LABEL = 'Test Drive';
  static readonly LEAD_TYPE_DEALER_CONTACT = 'Dealer Contact';  
  static readonly LEAD_TYPE_CONTACT_DEALER = 'Contact Dealer'; 
  static readonly MST_SELLING_PRICE = 'Selling Price';
  static readonly SALES_MANAGER = 'SALES_MANAGER';
  static readonly LEAD_TYPE_PAYMENT = 'Payment Estimate';
  static readonly LEAD_TYPE_SHARED_SAVES = "Online Saves";
  static readonly LEAD_TYPE_DEAL = "Deal";
  static readonly PRICING="pricing";
  static readonly DEALER ="dealer";
  static readonly PAYMENT  ="paymentestimation";
  static readonly SHAREDSAVE ="sharedsaves";
  static readonly FEATURES: any = {
    GROUPPRICE: {
      NAME: 'GroupPrice',
      ATTRIBUTES: {
        MAXNUMBER: 'Max Number'
      }
    }
  };
  static readonly ALL_ACTIVE_FEATURES = 'Import all active features';
  static readonly LAST_MODIFIED_BY = 'LAST MODIFIED BY';
  static readonly MONTLY_TERM_FINANCE = ['12', '24', '27', '36', '39', '48', '60', '63', '66', '72', '75', '84'];
  static readonly MONTLY_TERM_LEASE = ['12', '24', '27', '36', '39', '48', '60'];
  static readonly MONTHLY_TERM_LEASE_SET = ['24', '36', '39', '40', '42', '48', '51', '54', '60'];
  static readonly ERROR_MSG_MONTHLY_TERM_FINANCE = 'Allowed Terms for Finance are: 12, 24, 27, 36, 39, 48, 60, 63, 66, 72, 75, 84';
  static readonly ERROR_MSG_MONTHLY_TERM_LEASE = 'Allowed Terms for Lease are: 12, 24, 27, 36, 39, 48, 60';
  static readonly ERROR_MSG_MONTHLY_TERM_LEASE_SET = 'Allowed Terms for Lease are: 24, 36, 39, 40, 42, 48, 51, 54, 60';
  static readonly ERROR_MSG_DUPLICATE_TERM= 'Duplicate terms are not permitted.';
  static readonly SELECT_TERM = 'selectedTerm';
  static readonly DD_RTI_MST_CONSOLE = 'DD_RTI_MST_Console';
  static readonly WRITE_UP_PRICIED = 'Write-up Priced';
  static readonly EXPIRED = 'expired';
  static readonly CANCELLED = 'cancelled';
  static readonly EXPIRED_DATE = "Expired";
  static readonly NOTIFY = 'notify';
  static readonly CHAT = 'chat';
  static readonly MESSAGE_SENT = 'MESSAGE SENT';
  static readonly DEAL_NOTIFICATION_DIALOG_TITLE = 'WRITE-UP UPDATES';
  static readonly CHAT_NOTIFICATION_DIALOG_TITLE = 'MESSAGES';
  static readonly LEAD_LAST_MODIFIED_BY = "DG";
  static readonly DEAL_STATUS_FINALIZED = "Finalized";
  static readonly DEAL_STATUS_SENT_TO_FINANCE = "Sent to Finance";
  static readonly DEAL_STATUS_FINALIZED_CAP = "FINALIZED";
  static readonly DEAL_STATUS_DFI_SUBMITTED = "Dfi Submitted";
  static readonly DEAL_STATUS_DFI_SUBMITTED_CAP = "DFI SUBMITTED";
  static readonly DEAL_STATUS_CONTRACT_APPROVED = "Contract Approved";
  static readonly RECORD_TYPE = "RECORD TYPE";
  static readonly CUSTOMER_FIRST_NAME = "CUSTOMER FIRST NAME";
  static readonly CUSTOMER_LAST_NAME = "CUSTOMER LAST NAME";
  static readonly ORIGIN = "ORIGIN";
  static readonly VEHICLE_MODEL_YEAR = "MODEL YEAR";
  static readonly WRITEUP_EXPIRATION_DATE = "WRITE-UP EXPIRATION DATE";
  static readonly WRITEUP_TYPE = "WRITE-UP TYPE";
  static readonly CASH_DOWN_CASH = "CASH";
  static readonly TOTAL_DOWN_PAYMENT = "Total Down Payment";
  static readonly PRIOR_CREDIT_BALANCE = "PRIOR CREDIT BALANCE";
  static readonly NET_CAPITALIZED_COST = "Net Capitalized Cost";
  static readonly CAP_COST_REDUCTION = "CAP COST REDUCTION";
  static readonly BASE_MONTHLY_PAYMENT = "BASE MONTHLY PAYMENT";
  static readonly TRADE_IN_AMOUNT = "TRADE-IN AMOUNT";
  static readonly OUTSTANDING_BALANCE_ON_TRADE = "OUTSTANDING BALANCE ON TRADE";
  static readonly LEAD_ID = "LEAD ID";
  static readonly LEAD_TYPE = "Lead Type";
  static readonly OFFER_ID = "OFFER ID";
  static readonly WRITEUP_STATUS = "WRITE-UP STATUS";
  static readonly SALE_TYPE_COLUMN = "SALE TYPE";
  static readonly VEHICLE_TYPE_NEW = 'new';
  static readonly VEHICLE_TYPE_CERTIFIED = 'certified';
  static readonly VEHICLE_TYPE_CPO = 'cpo';
  static VEHICLE_TYPE_USED = 'used';
  static readonly OFFER_EXPIRATION = 'This Offer has expired.';
  static readonly VEHICLE_EXPIRATION = 'This Vehicle is no longer available.';
  static readonly ESTIMATE_EXPIRATION = 'This Estimate is no longer available.';
  static readonly SALES_CONSULTANT = 'SALES CONSULTANT';
  static readonly CURRENT_SALES_CONSULTANT = 'CURRENT SALES CONSULTANT';
  static readonly ORIGINAL_SALES_CONSULTANT = 'ORIGINAL SALES CONSULTANT';
  static readonly CURRENT_SERVICE_URL = "/offers/current?status=PENDING%20REVIEW,FINALIZED&visitedStatus=notVisited";
  static readonly TOTAL_PURCHASE_PRICE = "Total Purchase Price";
  static readonly TOTAL_VEHICLE_SELLING_PRICE = "Total Vehicle Selling Price";
  static readonly PROCTECTION_PRODUCTS = "Protection Products";
  static readonly PRODUCT_CHANGED = "PRODUCT_CHANGED";
  static readonly PRODUCT_VISIBLE = "PRODUCT_VISIBLE";
  static readonly PRODUCT_SELECTED = "PRODUCT_SELECTED";
  static readonly STANDARD_EQUIPMENT = 'STANDARD EQUIPMENT';
  static readonly SAFETY_AND_CONVENIENCE = 'SAFETY AND CONVENIENCE';
  static readonly MECHANICAL_AND_PERFORMANCE = 'MECHANICAL AND PERFORMANCE';
  static readonly INTERIOR = 'INTERIOR';
  static readonly EXTERIOR = 'EXTERIOR';
  static readonly OPTIONAL_EQUIPMENT = 'OPTIONAL EQUIPMENT';
  static readonly DEAL_UPDATE = 'DEAL_UPDATE';
  static readonly TMIS = 'TMIS';
  static readonly NON_TMIS = 'nontmis';
  static readonly GSFS = 'GSFS';
  static readonly LEASE_VARIANT_1PAY = '1PAY';
  static readonly OPTIONAL_TOYOTA_PRODUCTS = 'Optional Toyota Products';
  static readonly OPTIONAL_NON_TOYOTA_PRODUCTS = 'Optional Non-Toyota Products';
  static readonly OPTIONAL_LEXUS_PRODUCTS = 'Optional Lexus Products';
  static readonly OPTIONAL_NON_LEXUS_PRODUCTS = 'Optional Non-Lexus Products';
  static readonly OPTIONAL_TOYOTA_EXTRA_CARE_PRODUCTS = 'Optional Toyota Extra Care Products';
  static readonly OPTIONAL_NON_TOYOTA_EXTRA_CARE_PRODUCTS = 'Optional Non-Toyota Extra Care Products';
  static readonly OPTIONAL_FANDI_PRODUCTS = 'Optional F&I Products';
  static readonly OTHER_DEALER_FANDI_PRODUCTS = 'Other Dealer F&I Products';
  static readonly OPTIONAL_JMA_PRODUCTS = 'Optional Protection Products';
  static readonly OPTIONAL_NON_JMA_PRODUCTS = 'Optional Other Protection Products';
  static readonly PROVIDER = 'provider';
  static readonly IS_CAPITALIZED = 'capitalized';
  static readonly IS_TAXABLE = 'taxable';
  static readonly PRODUCT_DESCRIPTION = 'productDescription';
  static readonly PRODUCT_TERM = 'term';
  static readonly PRODUCT_MILAGE = 'mileage';
  static readonly PRODUCT_MAX_MONTHLY = 'maxMonthlyCovered';
  static readonly DD_PAC_MANAGEMENT = 'DD_PAC_Management';
  static readonly DD_PPM_PRESENTATION = 'DD_PPM_Presentation';
  static readonly DD_TFS_FS_PRESENTATION = 'DD_TFS_FS_Presentation';
  static readonly DD_FI_ADMINISTRATION = 'DD_FI_Administration';
  static readonly DD_TFS_IRATEBOOK = 'DD_TFS_iRatebook';
  static readonly DOFU_CHANGED = 'DOFU_CHANGED';
  static readonly MSTC_CUSTOMER_INTERESTED_PROTECTION_PRODUCTS = 'Customer Interested';
  static readonly CON = 'CON';
  static readonly PROTECTION = 'protection';
  static readonly OPTIONAL_FI_PRODUCTS = 'Optional F&I Products';
  static readonly OTHER_DEALER_FI_PRODUCTS = 'Other Dealer F&I Products';
  static readonly OPTIONAL_PROTECTION_PRODUCTS = 'Optional Protection Products';
  static readonly DASHBOARD = 'DASHBOARD';
  static readonly FILTERLABELDTAERANGE = 'Date Range';
  static readonly FILTERLABELWRITEUPSTATUS = 'Write-Up Status';
  static readonly FILTERLABELONLINESTATUS = 'Online Status';
  static readonly FILTERLABELPURCHASETYPE = 'Purchase Type';
  static readonly FILTERLABELSALETYPE = 'Sale Type';
  static readonly FILTERLABELSALESTEAM = 'Sales Team';
  static readonly webServiceTimeout = 30000;
  static readonly timeoutErrorCode = 'timeout';
  static readonly OFFERS_ = 'offers_';
  static readonly STANDARD_LOWER='standard';
  static readonly GOLD = 'Gold';
  static readonly SILVER = 'Silver';
  static readonly VehicleYEAR = 'year';
  static readonly VehicleMAKE = 'make';
  static readonly VehicleSERIES = 'series';
  static readonly VehicleMODELTRIM = 'model trim';
  static readonly VehicleSALESCLASS = 'sales class';
  static readonly VehicleTYPE = 'vehicle type';
  static readonly VehicleFUELTYPE = 'fuel type';
  static readonly VehicleHORSEPOWER = 'horse power';
  static readonly PAYMENT_ESTIMATE='Payment Estimate';
  static readonly ONLINE_CREDIT_APPLICATION ='Online Credit Application';
  static readonly CUSTOMER_VIEW ='cv/customer-view';
  static readonly DFI = 'DFI';
  static readonly CARS_DEALER_FLAG = 'PricingIncludingDealerFees';
  static readonly Business_OCA = 'Business OCA';
  static readonly Send_to_Deal_Jacket = 'Send to Deal Jacket';
  static readonly Desk_Deal = 'Desk Deal';
  static readonly FI_Admin_UI = 'FI Admin UI';
  static readonly Desking = 'Desking';
  static readonly Zero_Due_at_Signing = 'Zero Due at Signing';
  static readonly First_Payment_Due_at_Signing = 'First Payment Due at Signing';
  static readonly Payment_Grid_order = 'Payment Grid order';
  static readonly Rebate_Capitalization = 'Rebate Capitalization';
  static readonly Net_Trade_in_Capitalization = 'Net Trade-in Capitalization';
  static readonly Cashdown_Capitalization = 'Cashdown Capitalization';
  static readonly UVI_endpoint = 'UVI endpoint';
  static readonly Smartpath_Dealer = 'Smartpath Dealer';
  static readonly Residual_Override = 'Residual Override';
  static readonly Lease_Variant = 'Lease Variant';
  static readonly One_Pay_Lease = '1Pay Lease';
  static readonly Enable_Share_Features = 'Enable Share Features';
  static readonly OCA = 'OCA';
  static readonly OWNING_DEALER_LOCATION = 'Owning Dealer Location';
  static readonly TRADE_TAX_SAVINGS = 'Trade Tax Savings';
  static readonly Special_Rate_Toggle = 'Special Rate Toggle';
  static readonly Enable_Share_to_Online_Account = 'Enable Share to Online Account';
  static readonly TCUV = 'TCUV';
  static readonly Send_to_Transactions = 'Send to Transactions';
  static readonly Lease_Mileage_New = 'Lease Mileage New';
  static readonly Lease_Mileage_Certified = 'Lease Mileage Certified';
  static readonly Low_Mileage_Lease = 'Low Mileage Lease';
  static readonly NonToyotaProviderId = 'NonToyotaProviderId';
  static readonly MST_FEATURES = 'MST-FEATURES';
  static readonly Email = "Email";
  static readonly Website = "Website";
  static readonly Main_Dealer = "Main Dealer";
  static readonly SET_OCA= 'SET OCA';
  static readonly addressResultsCodes = {
    'AC01': 'The ZIP Code was changed or added.',
    'AC02': 'The State abbreviation was changed or added.',
    'AC03': 'The City name was changed or added.',
    'AC04': 'The USPS changed the address.',
    'AC05': 'The USPS changed the street name.',
    'AC06': 'Address1 and Address2 were swapped.',
    'AC07': 'Address1 and Company were swapped.',
    'AC08': 'The Plus 4 code was changed.',
    'AC09': 'The Puerto Rico Urbanization code was changed.',
    'AC10': 'The street name was changed.',
    'AC11': 'The street suffix abbreviation (st, rd, blvd) was changed.',
    'AC12': 'The street pre or post directional (n, sw, e) was changed.',
    'AC13': 'The suite or aparment name (apt, ste) was changed.',
    'AC14': 'The secondary unit number was changed or appended.',
    'AE01': 'The address could not be verified at least up to the postal code level.',
    'AE02': 'The street name was not found.',
    'AE03': 'Invalid Address Line 1. The suffix(AVE, ST, BLVD) is missing or invalid.',
    'AE04': 'The physical location exists but there are no addresses on this side of the street. Please provide a deliverable address.',
    'AE05': 'Multiple matching addresses found.',
    'AE07': 'The required combination of address/city/state or address/zip is missing.',
    'AE08': 'The suite or apartment number is not valid.',
    'AE09': 'The suite or apartment number is missing.',
    'AE10': 'The building or house number in the adress is not valid.',
    'AE11': 'The building or house number in the adress is missing.',
    'AE12': 'The input address box number is invalid.',
    'AE13': 'The input address box number is missing.',
    'AE15': unableToValidate,
    'AE16': unableToValidate,
    'AE17': 'Address does not have Suites or Apartments.',
    'AE18': 'Extra information found in address.',
    'AE19': unableToValidate,
    'AE20': unableToValidate,
    'AS02': 'The default building address was verified but the suite or apartment number is missing or invalid.',
    'AS09': 'Address in a non-supported country. (Should be handled as part of model validation)',
    'AS14': 'Appended a suite number using the address and company name.',
    'AS15': 'Appended an apartment number using the address and name.',
    'AS17': 'Address does not receive mail at this time. Please provide a deliverable address.',
    'AS18': 'Unable to perform address validation at this time. Try agin later or contact staff master support.'
  }
  static readonly successResultsCodes = ['AE06', 'AE14', 'AS01', 'AS03', 'AS10', 'AS13', 'AS16', 'AS20', 'AS22', 'As23'];
  static readonly fullStateNamesMappingArray = {
    'AL': 'ALABAMA', 'AK': 'ALASKA', 'AZ': 'ARIZONA', 'AR': 'ARKANSAS', 'CA': 'CALIFORNIA',
    'CO': 'COLORADO', 'CT': 'CONNECTICUT', 'DE': 'DELAWARE', 'DC': 'DISTRICT OF COLUMBIA', 'FL': 'FLORIDA', 'GA': 'GEORGIA', 'HI': 'HAWAII', 'ID': 'IDAHO', 'IL': 'ILLINOIS', 'IN': 'INDIANA', 'IA': 'IOWA',
    'KS': 'KANSAS', 'KY': 'KENTUCKY', 'LA': 'LOUISIANA', 'ME': 'MAINE', 'MD': 'MARYLAND',
    'MA': 'MASSACHUSETTS', 'MI': 'MICHIGAN', 'MN': 'MINNESOTA', 'MS': 'MISSISSIPPI',
    'MO': 'MISSOURI', 'MT': 'MONTANA', 'NE': 'NEBRASKA', 'NV': 'NEVADA', 'NH': 'NEW HAMPSHIRE',
    'NJ': 'NEW JERSEY', 'NM': 'NEW MEXICO', 'NY': 'NEW YORK', 'NC': 'NORTH CAROLINA',
    'ND': 'NORTH DAKOTA', 'OH': 'OHIO', 'OK': 'OKLAHOMA', 'OR': 'OREGON', 'PA': 'PENNSYLVANIA',
    'RI': 'RHODE ISLAND', 'SC': 'SOUTH CAROLINA', 'SD': 'SOUTH DAKOTA', 'TN': 'TENNESSEE',
    'TX': 'TEXAS', 'UT': 'UTAH', 'VT': 'VERMONT', 'VA': 'VIRGINIA', 'WA': 'WASHINGTON',
    'WV': 'WEST VIRGINIA', 'WI': 'WISCONSIN', 'WY': 'WYOMING'
  };
  static readonly TABGRID='tabgrid';
  static readonly TABSP='tabsp';
  static readonly TABTRADE='tabtrade';
  static readonly TABSIGNAL='tabsignal';
  static readonly TABADDONS='tabaddOns';
  static readonly TABPP='tabpp';
  static readonly TABINCENTIVES='tabincentives';
  static readonly TABCHAT='tabchat';
  static readonly TABLOG='tablog';
  static readonly TABTAXES='tabtaxes';
  static readonly TAXES_FEES_ACCORDION_UP='taxesfeesaccordionup';
  static readonly TAXES_FEES_ACCORDION_DOWN='taxeeesaccordiondown';
  static readonly BUTTON_PRINT_PAYMENT='printPaymentButton';
  static readonly BUTTON_EMAIL_PAYMENT='emailPaymentButton';
  static readonly BUTTON_PRINT_SELECTION='paymentSelectionButton';
  static readonly BUTTON_EMAIL_SELECTION='emailSelectionButton';
  static readonly PRICEGRID_WAIVE_SLIDER='pricegridwaiveslider';
  static readonly SILVER_CERTIFIED = "SILVER CERTIFIED";
  static readonly GOLD_CERTIFIED = "GOLD CERTIFIED";
  static readonly DEALER_RECOMMENDED = "Dealer Recommended Products";
  static readonly EVENT_PAGE_LOAD = 'pageload';
  static readonly AA_EVENT_PAGE_LOAD = 'aa-pageload';
  static readonly EVENT_LINK = 'link';
  static readonly CREDIT_APP_SUBMITTED = 'CREDIT APP SUBMITTED';
  static readonly RELEASE_TIME = new Date("2026-10-01T00:00:00Z").getTime();
  static readonly RELEASE_NAME = "September 2026";
}

